import { apiBasePath } from "../constants/constants";
import ApiService from "../utils/api-service";

export function getFormsApi(offset) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/forms`,
    params: {
      offset: offset * 20,
      max: 20,
    },
  });
}


export function addFormApi(data) {
  return ApiService({
    method: "POST",
    url: `${apiBasePath}/forms`,
    data,
  });
}

export function cloneFormApi(data) {
  return ApiService({
    method: "POST",
    url: `${apiBasePath}/forms/clone`,
    data,
  });
}

export function editFormApi(data) {
  return ApiService({
    method: "PUT",
    url: `${apiBasePath}/forms`,
    data,
  });
}

export function deleteFormApi(id) {
  return ApiService({
    method: "DELETE",
    url: `${apiBasePath}/forms/${id}`,
  });
}

export function togglePublishApi(id, published, data) {
  const { name, associatedBootcamps, description, type } = data;
  return ApiService({
    method: "PUT",
    url: `${apiBasePath}/forms`,
    data: { published: published, formId: id, bootcampIds: associatedBootcamps.map(el => el.id), label: name, description: description, type: type, allowResponseModify: data.allowResponseModify, enableViewForMentee: data.enableViewForMentee, },
  });
}

export function getBootCampsList(fromId) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/utilities/optionsForCreateEditForm`,
    params: fromId ? { formId: fromId } : {}
  })
}

export function saveAllFieldsApi(data) {
  const { id, createOrUpdate, ...rest } = data;
  let updatedpayload = createOrUpdate.map(el => ({ formId: id, ...el }))
  return ApiService({
    method: "POST",
    url: `${apiBasePath}/form/inputs`,
    data: { createOrUpdate: updatedpayload, ...rest },
  });
}

export function getformInputList(id) {
  return ApiService({
    method: "GET",
    url: `${apiBasePath}/form/inputs`,
    params: { formId: id }
  })
}


